export const Event = {
  SIDEBAR: {
    NOTIFY_EVENT: "leave-updated",
  },
};
